import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function AnalyticsIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'Grey6', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: [_jsx("path", { d: "M2 3V21H22", stroke: primaryFillColor, strokeWidth: 1.5, strokeLinecap: "round" }), _jsx("path", { d: "M5.5 16L9.5 9L15.5 12.5L20 5.5", stroke: primaryFillColor, strokeWidth: 1.5, strokeLinecap: "round" })] }));
}
//# sourceMappingURL=Analytics.js.map